import {formatDisplayPrice} from "../../../../../res/dataServices/pricing";

const CartConfirmationLine = ({ cartLine }) => {

    const product = cartLine.M_Product_ID;

    return (
        <>
            <div className="cart-confirm-line-grid">
                <p className="cart-line-h2">{product.value}</p>
                <p className="cart-line-h2">{product.name}</p>
                <p className="cart-line-h2 r">{cartLine.QtyEntered}</p>
                <p className="cart-line-h2">{cartLine.C_UOM_ID.identifier}</p>
                <p className="cart-line-h2 r">{formatDisplayPrice(cartLine.PriceEntered)}</p>
                <p className="cart-line-h2 r">{formatDisplayPrice(cartLine.LineNetAmt)}</p>
            </div>
        </>
    )
}

const CartConfirmationLines = ({ completedOrder }) => {

    const lines = completedOrder.products.lines;

    return (
        <>
            <div className="cart-confirm-line-grid">
                <p className="cart-h">Code</p>
                <p className="cart-h">Description</p>
                <p className="cart-h">Qty</p>
                <p className="cart-h">Per</p>
                <p className="cart-h">Price</p>
                <p className="cart-h">Amount</p>
            </div>
            {lines.map((l,i) =>
                <CartConfirmationLine key={i} cartLine={l} />
            )}
        </>
    )
}

export default CartConfirmationLines;
